import { render, staticRenderFns } from "./PowerInfo.vue?vue&type=template&id=28988dfe&"
import script from "./PowerInfo.vue?vue&type=script&lang=js&"
export * from "./PowerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports